import PropTypes from "prop-types";
import classNames from "classnames";
import { Button } from "reactstrap";
import React from "react";
import "./ShowButton.scss";
/**
 * Tlačítko zobrazit
 */

class ShowButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    hideInMd: PropTypes.func,
    title: PropTypes.string,
  };
  static defaultProps = {
    title: "Zobrazit",
  };

  render() {
    const { onClick, title, className, hideInMd, ...other } = this.props;
    const cls = classNames("show-button", className, {
      "d-md-none d-lg-block": hideInMd,
    });
    return (
      <Button className={cls} onClick={onClick} color={"primary"} {...other}>
        {title}
      </Button>
    );
  }
}

export default ShowButton;
